import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CompliancePredesDestinationImpcCodeNotRegisteredReport
  from '../components/CompliancePredesDestinationImpcCodeNotRegisteredReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CompliancePredesDestinationImpcCodeNotRegisteredSummarySelectors';

export function CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer(props) {
  return (
    <CompliancePredesDestinationImpcCodeNotRegisteredReport
      reportId={ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CompliancePredesDestinationImpcCodeNotRegisteredSummaryContainer);
